module.exports = __webpack_public_path__ + "img/session-faild.449a91b0.jpg";